import React from 'react';

const AccessLevelTag = ({ accessLevel }) => {
  const accessLevelMap = {
    custom: 'limited',
    reader: 'on',
  };

  const label = accessLevelMap[accessLevel] || 'off';

  return accessLevel ? <span className={`role-tag role-${label}`}>{label}</span> : null;
};

export const ListItemComponent = ({ before, item, onClick, chooseItemName = item => item.name }) => (
  <li>
    {before}
    <a onClick={() => onClick(item)}>
      <AccessLevelTag accessLevel={item?.access?.role} />
      <span className="label">{t(chooseItemName(item))}</span>
    </a>
  </li>
);
